import { render, staticRenderFns } from "./NewDesignCaseStudy.vue?vue&type=template&id=472734f5&"
import script from "./NewDesignCaseStudy.vue?vue&type=script&lang=js&"
export * from "./NewDesignCaseStudy.vue?vue&type=script&lang=js&"
import style0 from "./NewDesignCaseStudy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ATextblock: require('/app/components/ATextblock.vue').default})
